import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bulma/css/bulma.css'
import { RouterProvider } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

import router from './router.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
